<template>
  <div>
    <nav class="col-12">
      <div class="fs-title border-line m-auto px-0 fw-bold">
        <span>가입 신청서 작성</span>
      </div>
    </nav>
    <section class="d-flex flex-column gap-4 mt-3">
      <article>
        <div class="fs-nav fw-bold">기본정보 입력</div>
        <div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label for="person_name" class="form-label mb-0 fs-label">성명</label>
            </div>
            <div class="w-input px-0">
              <input type="text" class="form-control fs-input" id="person_name" v-model="memberCreateParam.name"
                     :readonly="testReadonly">
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label for="person_mobile" class="form-label mb-0 fs-label">핸드폰번호</label>
            </div>
            <div class="w-input px-0">
              <input type="text" class="form-control fs-input" id="person_mobile" v-model="memberCreateParam.mobile"
                     :readonly="testReadonly">
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label class="form-label mb-0 fs-label">주민번호</label>
            </div>
            <div class="input-group custom-input-group px-0 w-input">
              <input type="tel" class="form-control fs-input4 px-1 text-start pb-0" style="width: 30%"
                     v-model="memberCreateParam.corp_ceo_personno1" :readonly="testReadonly">
              <div class="input-group-text px-2 mt-1">-</div>
              <input type="tel" class="form-control fs-input px-1 text-start pb-0 input-none"
                     :value="constGender" readonly>
              <input type="tel" class="form-control fs-input px-0 text-start pb-0" style="width: 30%"
                     ref="corp_ceo_personno_tmp"
                     :maxlength="personNoLength"
                     :value="memberCreateParam.corp_ceo_personno_tmp" @input="inputPersonNo">
              <button class="btn btn-primary valid-btn" type="button" @click="validPersonNo">인증</button>
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label for="address1" class="form-label mb-0 fs-label">주소<span v-if="joinUrl === 'mancharo'"
                                                                             class="text-primary"> (선택)</span></label>
            </div>
            <!--            -->
            <div class="w-input px-0">
              <div class="input-group custom-input-group mb-0" @click="searchPostCode">
                <input id="address1" type="text" class="form-control fs-input" placeholder="검색을 눌러주세요"
                       ref="address1"
                       :value="memberCreateParam.address1" :readonly="testReadonly">
                <button class="btn btn-primary  fs-label valid-btn" type="button" id="searchPostCode">검색</button>
              </div>
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="d-flex align-items-center px-0">
              <div class="w-label">
                <label for="person_address2" class="form-label mb-0 fs-label">상세주소<span v-if="joinUrl === 'mancharo'"
                                                                                        class="text-primary"> (선택)</span>
                </label>
              </div>
              <div class="w-input px-0 label-container">
                <input type="text" class="form-control fs-input text-start" id="person_address2"
                       placeholder="상세주소를 입력해주세요."
                       @input="changeDetailAddress">
              </div>
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label for="carNumber" class="form-label mb-0 fs-label">차량번호</label>
            </div>
            <div class="w-input px-0">
              <input type="text" id="carNumber" class="form-control fs-input"
                     ref="user_carnum" @input="changeCarNum">
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label for="carType" class="form-label mb-0 fs-label">차량 종류</label>
            </div>
            <div class="w-input px-0">
              <div class="input-group custom-input-group px-0">
                <select class="form-select col-2 fs-input custom-select" id="carType"
                        v-model="carType" @change="carTypeChange" ref="user_cartype">
                  <option value="" disabled>선택</option>
                  <option v-for="(car_type, index) in carTypeArray" :key="index" :value="car_type.option_code">
                    {{ car_type.option_name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label for="carSize" class="form-label mb-0 fs-label">차량 톤수</label>
            </div>
            <div class="w-input px-0">
              <div class="input-group custom-input-group px-0">
                <select class="form-select col-2 fs-input custom-select" id="carSize"
                        v-model="carSize" @change="carSizeChange" ref="user_carsize">
                  <option value="" disabled>선택</option>
                  <option v-for="(car_size, index) in carSizeArray" :key="index" :value="car_size.option_code">
                    {{ car_size.option_name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div v-if="this.joinUrl === 'mancharo'" class="row align-items-center mx-0">
            <div class="w-label">
              <label for="carSize" class="form-label mb-0 fs-label">그룹(지역)</label>
            </div>
            <div class="w-input px-0">
              <div class="input-group custom-input-group px-0">
                <select class="form-select col-2 fs-input custom-select" ref="user_group"
                        v-model="memberCreateParam.group_code">
                  <option :value="null" disabled>선택</option>
                  <option v-for="(mancharo, index) in mancharoArray" :key="index" :value="mancharo.option_code">
                    {{ mancharo.option_name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article>
        <div class="fs-nav fw-bold">사업자 정보 입력</div>
        <div>
          <div class="row align-items-center mx-0 px-0">
            <div class="w-label">
              <label for="corp_num" class="form-label mb-0 fs-label">사업자번호</label>
            </div>
            <div class="w-input px-0">
              <div class="input-group custom-input-group mb-0">
                <input id="corp_num" type="tel" class="form-control fs-input"
                       :value="memberCreateParam.corp_num" ref="corp_num"
                       maxlength="10"
                       @input="inputCorpNum">
                <button class="btn btn-primary fs-label valid-btn" type="button" @click="validCorpNum">인증</button>
              </div>
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="px-0 pb-1 w-label">
              <label for="corp_email" class="form-label mb-0 fs-label">이메일<span
                  class="text-primary"> (선택)</span></label>
            </div>
            <div class="input-group custom-input-group px-0 w-input">
              <input type="text" class="form-control px-1 fs-input" id="corp_email"
                     v-model="tmp_corp_email" ref="corp_email">
              <div class="input-group-text px-2 fs-label mt-1" v-if="selectEmail !== ''">@</div>
              <select class="form-select fs-label email-select" v-model="selectEmail">
                <option v-for="(email, index) in emails" :key="index" :value="email.value">{{ email.label }}</option>
              </select>
            </div>
          </div>
        </div>
      </article>
      <article>
        <div class="fs-nav fw-bold">계좌정보 입력<span v-if="joinUrl === 'mancharo'" class="text-primary"> (선택)</span></div>
        <div class="d-flex flex-column gap-1 mt-2">
          <div class="d-flex">
            <div class="w-label"><span class="mb-0 fs-label">계좌구분</span></div>
            <div class="d-flex gap-3">
              <div class="form-check">
                <input class="form-check-input fs-input" type="radio" name="flexRadioDefault" id="bank_person" value="1"
                       v-model="bankGubun">
                <label class="form-check-label fs-label" for="bank_person">
                  개인계좌
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input fs-input" type="radio" name="flexRadioDefault" id="bank_company"
                       value="2" v-model="bankGubun">
                <label class="form-check-label fs-label" for="bank_company">
                  법인계좌
                </label>
              </div>
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label for="bankName" class="form-label mb-0 fs-label">은행명</label>
            </div>
            <div class="w-input px-0">
              <div class="input-group custom-input-group px-0">
                <select class="form-select col-2 fs-input custom-select" id="bankName"
                        @change="selectBankChange" ref="rbank_type" v-model="selectBank">
                  <option value="" disabled>선택</option>
                  <option v-for="(bank, index) in bankArray" :key="index" :value="bank.option_code">{{
                      bank.option_name
                    }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row align-items-start mx-0">
            <div class="w-label">
              <label class="form-label mb-0 fs-label">예금주</label>
            </div>
            <div class="w-input px-0">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="bankNameBox" v-model="bankNameSame">
                <label class="form-check-label" for="bankNameBox">예금주(성명)동일</label>
              </div>
              <input type="text" class="form-control fs-input" placeholder="예금주명을 입력하세요"
                     :value="memberCreateParam.rbank_username" @input="inputBankName" ref="rbank_username">
            </div>
          </div>
          <div class="row align-items-center mx-0">
            <div class="w-label">
              <label for="bank_num" class="form-label mb-0 fs-label">계좌번호</label>
            </div>
            <div class="w-input px-0 d-flex">
              <div class="input-group custom-input-group mb-0">
                <input id="bank_num" type="tel" class="form-control fs-input" placeholder="숫자만 입력해주세요."
                       @input="inputBankNumber" ref="rbank_num">
                <button class="btn btn-primary fs-label valid-btn" type="button" @click="validBank">계좌인증</button>
              </div>
            </div>
          </div>
          <div class="border p-2 rounded-1 border-primary mt-1">
            <div class="w-100 text-info">※ [안내] 가입자가 아닌, 타인 소유의 계좌로 가입 신청을 원하시는 경우 화물맨 고객센터로 문의 바랍니다. (1660-0303)</div>
          </div>
        </div>
      </article>
      <article>
        <div class="d-flex flex-column gap-1">
          <div class="form-check">
            <input type="checkbox" class="form-check-input custom-checkbox fs-input" id="selectAll" v-model="selectAll"
                   @change="toggleSelectAll">
            <label class="form-check-label fw-bold" for="selectAll">
              이용약관 전체동의
            </label>
          </div>
          <div class="form-check p-0" v-for="(item, index) in items" :key="index">
            <div class="mx-4 d-flex justify-content-between mr-0 align-items-center">
              <div>
                <input type="checkbox" class="form-check-input custom-checkbox fs-input" :id="'checkbox-' + item.id"
                       v-model="selectedItems[item.id]" @change="updateSelectAll">
                <label class="form-check-label" :for="'checkbox-' + item.id">
                  {{ item.name }}
                  <span v-if="item.required" class="text-danger">*</span>
                </label>
              </div>
              <!--                <button @click="item.show = true" class="modal-btn"><i class="bi bi-chevron-double-right"></i></button>-->
              <div>
                <span v-if="item.id !== 999" @click="item.show = true" class="badge bg-info p-info">약관보기</span>
                <span v-if="item.id === 999" @click="item.show = true" class="badge bg-info p-info">내용보기</span>
              </div>
            </div>
            <!-- 모달 컴포넌트 -->
            <ModalView :showModal="item.show" :title="item.name" :content="item.content">
              <template>
                <!-- 모달 닫기 버튼 -->
                <div class="d-flex gap-2 justify-content-end">
                  <button class="btn btn-dark mt-4" @click="item.show = false">닫기</button>
                  <button class="btn btn-primary mt-4" @click="ok(item)">동의합니다.</button>
                </div>
              </template>
            </ModalView>
          </div>
        </div>
      </article>
      <article>
        <div class="d-flex justify-content-center flex-column gap-2">
          <div class="fs-label fw-bold">신청인 서명</div>
          <canvas
              id="sign-canvas"
              ref="canvas"
              class="signature-canvas-element rounded m-auto"
              @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing" @mouseleave="stopDrawing"
              @touchstart="startDrawingTouch" @touchmove="drawTouch" @touchend="stopDrawingTouch"
          ></canvas>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary col-3" @click="clearCanvas">지우기</button>
          </div>
        </div>
      </article>
    </section>
    <footer class="col-12 my-4">
      <button class="btn btn-primary w-100" @click="summit">가입 신청서 제출하기</button>
    </footer>
  </div>
</template>

<script>

import ModalView from "@/modal/ModalView.vue";
import {SHA256} from "@/assets/js/common";
import {isSocialLogin} from "@/assets/js/SocialLoginComposables";

const requiredFieldList = [ //필수항목
  'corp_ceo_personno_tmp',
  'address1',
  'user_carnum',
  'user_cartype',
  'user_carsize',
  'corp_num',
  'corp_email',
  'rbank_type',
  'rbank_typecode',
  'rbank_username',
  'rbank_num',
  'agree',
  'img_sign'
]
const fieldErrorMessageArray = {
  corp_ceo_personno_tmp: '주민번호 뒷자리를 입력해주세요.',
  address1: '주소를 입력해주세요.',
  user_carnum: '차량번호를 입력해주세요.',
  user_cartype: '차량종류를 선택해주세요.',
  user_carsize: '차량톤수를 선택해주세요.',
  corp_num: '사업자번호를 입력해주세요.',
  corp_email: '이메일을 입력해주세요.',
  rbank_type: '은행명을 선택해주세요.',
  rbank_username: '예금주를 입력해주세요.',
  rbank_num: '계좌번호를 입력해주세요.',
  agree: '약관에 모두 동의해주세요.',
  img_sign: '신청인 서명을 해주세요'
}

export default {
  name: "JoinHmm",
  components: {
    ModalView,
  },
  data() {
    return {
      iv: this.$CryptoJS.enc.Hex.parse('0000000000000000'),
      key: this.$CryptoJS.enc.Utf8.parse('alkdjalsdjivlake'),
      items: [
        {id: 1, show: false, name: '정보망서비스 이용약관', content: '', required: true},
        {id: 2, show: false, name: '선착불 수수료 자동정산', content: '', required: true},
        {id: 5, show: false, name: '위치기반 서비스 이용약관', content: '', required: true},
        {id: 6, show: false, name: '개인정보동의(제3자 제공동의)', content: '', required: true},
        {id: 99, show: false, name: '정보이용료 자동출금 동의약관', content: '', required: true},
        {id: 999, show: false, name: '예치금운용동의', content: '', required: true},
        {id: 'marketing_agreement', show: false, name: '마케팅 정보 수신 동의(선택)', content: '', required: false}
      ],
      emails: [
        {value: '', label: '직접입력'},
        {value: '@naver.com', label: '네이버'},
        {value: '@hanmail.net', label: '한메일'},
        {value: '@gmail.com', label: 'gmail'},
        {value: '@nate.com', label: '네이트'},
        {value: '@daum.net', label: '다음'},
        {value: '@kakao.com', label: '카카오'},
        {value: '@yahoo.co.kr', label: '야후'},
        {value: '@bill36524.com', label: '더존'},
        {value: '@hometax.go.kr', label: '홈택스'},
      ],
      selectedItems: {},
      selectAll: false,
      drawing: false,
      // canvasWidth: 300,
      // canvasHeight: 200,
      signatureData: null, // 추가: 서명 데이터를 저장할 변수,
      showModal: false,
      memberInfo: {
        img_sign: '',
      },
      memberCreateParam: {
        act_app: 101,
        name: "", // 이름
        mobile: "", // 전화번호
        birthday: "", //생년월일 + 성별코드
        corp_ceo_personno1: "", //주민번호 앞자리
        corp_ceo_personno2: "", //주민번호 뒷자리
        corp_ceo_personno_tmp: "", //주민번호 암호화전 뒷자리

        address1: "", //주소
        address2: "",	//상세주소
        zipcode: "", //주소우편번호
        user_carnum: "",	//차량번호
        user_cartype: "",	//차종
        user_cartypecode: -1,	//차종코드
        user_carsize: "",	//차 사이즈
        user_carsizecode: -1,	//차 사이즈코드
        group_code: null,//개별협회 코드
        grade_code: null,//회원구분 (모바일 8,만차로구분 11,아틀란 12)

        corp_num: "", //사업자번호
        email: "",	//사용자 이메일 (non-required)
        taxemail: "", //전자계산서 이메일 (non-required)

        rbank_type: "",	//계좌구분
        rbank_typecode: "",	//은행코드
        rbank_num: "",	//계좌번호
        rbank_username: "",	//예금주

        img_sign: "",	//서명정보
        img_usersign: "", //예금주서명

        //차주 예치금 운용동의
        point_used_agree: `Y`,

        phone_check : 1, //본인인증 1:인증 0:미인증
        car_check   : 0, //차량인증 1:인증 0:미인증
        corp_check  : 0, //사업자인증 1:인증 0:미인증
        rbank_check : 0, //은행인증 1:인증 0:미인증
        rbank_typecode_num : null,// 계좌구분 1:개인계좌, 2:법인계좌
        marketing_agree: 'N', // 마케팅 정보 수신 동의 (Y/N)
      },
      carSizeArray: [
        {
          option_code: '',
          option_name: '',
          sort: ''
        }
      ],
      carTypeArray: [
        {
          option_code: '',
          option_name: '',
          sort: ''
        }
      ],
      mancharoArray: [
        {
          option_code: '',
          option_name: '',
          sort: ''
        }
      ],
      carSize: '',
      carType: '',
      selectEmail: '',
      customEmail: '',
      selectBank: '',
      gender: '',
      bankGubun: '', // 1 : 개인계좌 , 2 : 법인계좌
      bankArray: [
        {
          option_code: '',
          option_name: '',
          sort: ''
        }
      ],
      bankCode: '0',
      bankNameSame: false,
      bizno: '',
      validList: {
        person_no: false,
        corp_no: false,
        bank_no: false,
        sign: false
      },
      validArray: requiredFieldList,
      validMessageArray: fieldErrorMessageArray,
      constGender: '',
      tmp_corp_email: '',
      addressShow: false,
      joinUrl: '',
      isTestEnv: false,
      testReadonly: true,
      personNoLength: 6 // 주민등록번호
    }
  },
  watch: {
    bankNameSame(statue) {
      if (statue) {
        this.memberCreateParam.rbank_username = this.memberCreateParam.name;
      }
    },
  },
  async mounted() {
    // TODO 세션테스트
    const canvas = document.body.querySelector('#sign-canvas');
    canvas.width = window.innerWidth * 0.90;
    canvas.height = canvas.width * 0.429;
    canvas.style.width = canvas.width + 'px';
    canvas.style.height = canvas.height + 'px';

    const memberInfo = this.$store.getters.getMemberInfo;
    this.initMemberInfo(memberInfo);

    this.joinUrl = this.$store.getters.getJoinUrl;
    this.memberCreateParam.grade_code = this.$store.getters.getGradeCode;
    // 테스트 환경 ( readonly )
    this.isTestEnv = this.$store.getters.getTestEnv;
    if (this.isTestEnv) {
      // 테스트 환경일 때
      this.memberCreateParam.corp_ceo_personno_tmp = this.generatedUserId();
      this.testReadonly = false;
    } else {
      this.testReadonly = true;
    }

    if (this.joinUrl === 'mancharo') {
      this.getMancharoList();
    }

    this.findCarType();
    this.findCarSize();
    this.findBankCode();

    console.log(`localStorage.getItem("join-url") => `, localStorage.getItem("join-url"));

    await this.items.forEach(
        item => {
          if (item.id === 99) {
            item.content =
                '<p>신청인(예금주)은 CMS 자동 출금이체 등에<br>' +
                '대해 구체적으로 인식하고 있으므로,<br>' +
                '해당 계좌에서 정보이용료가 지정된 날짜에<br>' +
                '자동 인출되어 결제하는데 동의합니다.</p>' +
                '<p class="fs-5">본 약관을 거부하시는 경우에는<br>' +
                '회원가입이 불가합니다.</p>'
          } else if (item.id === 999) {
            item.content =
                '<p> 화물운송비 지급 지연과 원활하지 않는 수금으로 인한 불편을 최소화하고자,\n' +
                '        회원님들께서 예치한 예치금을 운영하여 회원님들께 편의와 혜택을 드리고자 합니다\n' +
                '    </p>\n' +
                '    <ul style="padding:0 ;margin: 15px">' +
                '        <li>예치금 운용목적 : 회사에서 운송서비스, 예치금운영비로 운용 (「약관의 규제에 관한 법률」 제12조 제1호)</li>\n' +
                '        <li>예치금은 기존과 동일하게 사용가능합니다</li>\n' +
                '    </ul>'
          } else {
            this.$http(`/api/terms/${item.id}`)
                .then(response => item.content = response.data);
          }
        });
    if (this.$store.getters.getIsSocialLogin) {
      this.personNoLength = 7;
    } else {
      this.personNoLength = 6;
    }
  },
  methods: {
    // 전체 선택 버튼을 클릭했을 때 개별 체크박스들을 변경
    toggleSelectAll() {
      const newSelectAllState = this.selectAll;
      this.items.forEach(item => {
        this.selectedItems[item.id] = newSelectAllState;
      });
    },
    // 개별 체크박스가 변경될 때 전체 선택 버튼 상태를 업데이트
    updateSelectAll() {
      this.selectAll = this.isAllAgreed();
    },
    startDrawing(event) {
      this.drawing = true;
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      ctx.beginPath();
      const x = event.offsetX;
      const y = event.offsetY;
      ctx.moveTo(x, y);
    },
    draw(event) {
      if (!this.drawing) return;
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      const x = event.offsetX;
      const y = event.offsetY;
      ctx.lineTo(x, y);
      ctx.stroke();
    },
    stopDrawing() {
      if (this.drawing) {
        this.drawing = false;
        this.saveSignature();
      }
    },
    startDrawingTouch(event) {
      const touch = event.touches[0];
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      const x = touch.clientX - rect.left;
      const y = touch.clientY - rect.top;
      const ctx = canvas.getContext("2d");
      ctx.beginPath();
      ctx.moveTo(x, y);

      if (
          touch.clientX >= rect.left &&
          touch.clientX <= rect.right &&
          touch.clientY >= rect.top &&
          touch.clientY <= rect.bottom
      ) {
        this.drawing = true;
      } else {
        this.stopDrawingTouch();
      }
    },
    drawTouch(event) {
      if (!this.drawing) return;
      event.preventDefault();
      const touch = event.touches[0];
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      const x = touch.clientX - rect.left;
      const y = touch.clientY - rect.top;
      const ctx = canvas.getContext("2d");
      ctx.lineTo(x, y);
      ctx.stroke();
    },
    stopDrawingTouch() {
      if (this.drawing) {
        this.drawing = false;
        this.saveSignature();
      }
    },
    clearCanvas() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.signatureData = null;
      this.validList.sign = false;
    },
    saveSignature() {
      const canvas = this.$refs.canvas;
      this.signatureData = canvas;
      this.validList.sign = true;
    },
    ok(modal) {
      this.selectedItems[modal.id] = true;
      this.updateSelectAll();
      modal.show = false;
    },
    isAllAgreed() {
      return this.items.filter(item => item.required).every(item => {
        return this.selectedItems[item.id] === true;
      });
    },
    isAllRequiredAgreed() {
      return this.items.filter(item => item.required).every(item => {
        return this.selectedItems[item.id] === true;
      });
    },
    async fileUpload() {

      const data = atob(this.signatureData.toDataURL("image/png").split(",")[1]);
      const array = [];
      for (let i = 0; i < data.length; i++) {
        array.push(data.charCodeAt(i));
      }
      const SignFile = new Blob([new Uint8Array(array)], {type: 'image/png'});
      const formData = new FormData();
      formData.append("file", SignFile, "SignFile.png");

      const config = {
        headers: {
          'Content-Type': "multipart/form-data",
        },
      };
      await this.$http.post('/api/add/submit', formData, config)
          .then(response => {
            this.memberCreateParam.img_sign = response.data;
            this.memberCreateParam.img_usersign = response.data;
          })
          .catch(err => this.$swal.file("사인 업로드에 실패하였습니다. 오류: " + err))
    },
    searchPostCode() {
      new window.daum.Postcode({
        oncomplete: (data) => {
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.
          // 각 주소의 노출 규칙에 따라 주소를 조합한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          let addr = ''; // 주소 변수
          let extraAddr = ''; // 참고항목 변수
          //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
          if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
          } else { // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
          }
          // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
          if (data.userSelectedType === 'R') {
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
              extraAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if (data.buildingName !== '' && data.apartment === 'Y') {
              extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if (extraAddr !== '') {
              extraAddr = ' (' + extraAddr + ')';
            }
          }
          this.memberCreateParam.address1 = addr;
          this.memberCreateParam.zipcode = data.zonecode; // 우편번호
          this.memberCreateParam.address2 = extraAddr;
        }
      }).open();
    },
    findCarType() {
      const param = {
        option: 'optCarTypecode'
      }
      this.$http.post('/api/simplejoin/config', param)
          .then(response => {
            this.carTypeArray = response.data.data.sort((a, b) => a.sort - b.sort);
          })
          .catch(console.log);
    },
    findCarSize() {
      const param = {
        option: 'optCarSizecode'
      }
      this.$http.post('/api/simplejoin/config', param)
          .then(response => {
            this.carSizeArray = response.data.data.sort((a, b) => a.sort - b.sort);
          })
          .catch(console.log);
    },
    findBankCode() {
      const param = {
        option: 'optBankCode'
      }
      this.$http.post('/api/simplejoin/config', param)
          .then(response => {
            this.bankArray = response.data.data.sort((a, b) => a.sort - b.sort);
            this.bankArray.forEach(bank => {
              bank.option_code = String(bank.option_code).padStart(3, '0')
            });
            if (this.joinUrl === 'mancharo') {
              this.bankArray.unshift({
                option_code: '',
                option_name: '선택안함',
                sort: '0'
              });
            }
          })
          .catch(console.log);
    },
    getMancharoList() {
      const param = {
        option: 'optBankCode'
      }
      this.$http.post('/api/simplejoin/config/mancharo', param)
          .then(response => {
            this.mancharoArray = response.data.data.sort((a, b) => a.sort - b.sort);
          })
          .catch(console.log);
    },
    async validCorpNum() {
      let corp_no = this.memberCreateParam.corp_num;
      if (this.isEmpty(corp_no)) {
        await this.$swal.fire({title: '입력된 번호가 없습니다.'});
        return;
      }
      corp_no = corp_no.replace(/\s+/g, '');
      corp_no = corp_no.replace(/[^0-9-]/g, '');

      const hmmBizno = corp_no + "HMM";
      const hashBizno = SHA256(hmmBizno);
      const requestParam = {
        hash: hashBizno.substring(0, 64),
        bizno: corp_no
      }
      await this.$http.post('/api/check/bizregno', requestParam)
          .then(response => {
            const result = response.data.data.is_pass_corp_check;
            this.memberCreateParam.corp_check = response.data.data.corp_check;
            if (result === "Y") {
              this.validList.corp_no = true;
              this.memberCreateParam.corp_num = corp_no;
              this.$swal.fire({title: '인증 성공'});
              return;
            }
            this.$swal.fire({title: '사업자등록번호를 올바르게 입력해주세요.'})
            this.validList.corp_no = false;
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            this.validList.corp_no = false;
            this.$swal.fire('사업자등록번호를 올바르게 입력해주세요.');
          });
    },
    validPersonNo() {
      //TODO 주민등록번호 암호화후 검증 - 2020년생 검증 X
      const person_no = this.constGender + this.memberCreateParam.corp_ceo_personno_tmp;

      this.memberCreateParam.corp_ceo_personno2 = this.$CryptoJS.AES.encrypt(
          //주민번호 뒷자리 암호화
          person_no,
          this.key,
          {
            iv: this.iv,
            mode: this.$CryptoJS.mode.CBC,
            keySize: 256 / 32,
            padding: this.$CryptoJS.pad.Pkcs7,
          },
      ).toString();

      this.$http.post('/api/simplejoin/validate-no', {
        corp_ceo_personno1: this.memberCreateParam.corp_ceo_personno1,
        corp_ceo_personno2: this.memberCreateParam.corp_ceo_personno2, //여기만 수정하면됨
      })
          .then(response => {
            if (!response.data.error) {
              //성공
              this.validList.person_no = true;
              this.$swal.fire({title: '인증 성공'});
              return;
            }
            //실패
            this.$swal.fire({title: response.data.message});
          })
          // eslint-disable-next-line no-unused-vars
          .catch(ex => {
            this.$swal.fire({title: '오류발생'})
          });
    },
    validBank() {
      //평생 계좌 인증
      if (
          !this.isEmpty(this.memberCreateParam.rbank_num) &&
          this.memberCreateParam.rbank_num === this.memberCreateParam.mobile
      ) {
        this.$swal.fire('평생계좌번호는 인증이 불가하오니<br>실 계좌번호 입력 부탁드립니다.');
        return;
      }
      if (this.bankGubun === '2' && this.validList.corp_no === false) {
        // 법인계좌는 사업자 번호 인증이 필수입니다.
        this.moveFocus('corp_num');
        this.$swal.fire('사업자 번호를 인증을 해주세요.');
        return;
      }

      let accountNumber = '';
      let resId = '';

      if (this.bankGubun === '2') {
        // 2: 법인 계좌
        accountNumber = this.memberCreateParam.rbank_num + this.memberCreateParam.corp_num.substring(0, 10) + "HMM"; // 사업자번호
        resId = this.memberCreateParam.corp_num.substring(0, 10); // 사업자번호
      } else {
        // 1: 개인 계좌 및 개인 사업자
        accountNumber = this.memberCreateParam.rbank_num + this.memberCreateParam.corp_ceo_personno1.substring(0, 6) + "HMM";
        resId = this.memberCreateParam.corp_ceo_personno1.substring(0, 6);
      }

      const hashSha256 = SHA256(accountNumber);
      const bankGubun = this.bankGubun;
      const parameter = {
        hash: hashSha256.substring(0, 64),
        service: '1',
        svcGbn: '5',
        strGbn: bankGubun,
        strBankCode: this.memberCreateParam.rbank_typecode,
        strAccountNo: this.memberCreateParam.rbank_num,
        strNm: this.memberCreateParam.rbank_username,
        strResId: resId
      }
      this.$http.post('/api/check/account', parameter)
          .then(response => {
            if (response.data.data.resultCode === "0000") {
              this.validList.bank_no = true;
              this.memberCreateParam.rbank_check = 1;
              // 계좌인증 성공시 계좌구분 저장
              this.memberCreateParam.rbank_typecode_num = bankGubun;
              this.$swal.fire({title: '계좌 인증에 성공했습니다.'})
            } else {
              this.$swal.fire({title: '인증실패'})
              this.validList.bank_no = false;
              this.memberCreateParam.rbank_check = 0;
              this.memberCreateParam.rbank_typecode_num = null;
            }
          })
          .catch(() => {
            this.$swal.fire({title: '인증실패'})
            this.validList.bank_no = false;
            this.memberCreateParam.rbank_check = 0;
            this.memberCreateParam.rbank_typecode_num = null;
          });
    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
    isValidBankInfo() {
      return this.validList.bank_no === false;
    },
    async summit() {
      // 검증
      if (!this.isTestEnv) {
        if (this.validList.person_no === false) {
          this.moveFocus('corp_ceo_personno_tmp');
          await this.$swal.fire('주민번호 인증을 해주세요');
          return;
        }
        if (this.joinUrl !== 'mancharo' && this.isEmpty(this.memberCreateParam.address1)) {
          this.moveFocus('address1');
          await this.$swal.fire('주소를 검색후\n입력해주세요.');
          return;
        }
        //차량번호검사
        if (!this.validCarNum()) {
          return;
        } else {
          this.memberCreateParam.car_check = 1; // 차량인증 성공
        }
        if (this.isEmpty(this.memberCreateParam.user_cartype)) {
          this.moveFocus('user_cartype');
          await this.$swal.fire('차량종류를 선택해주세요.');
          return;
        }
        if (this.isEmpty(this.memberCreateParam.user_carsize)) {
          this.moveFocus('user_carsize');
          await this.$swal.fire('차량톤수를 선택해주세요.');
          return;
        }
        //개별협회 전용 validate
        if (this.joinUrl === 'mancharo') {
          if (this.isEmpty(this.memberCreateParam.group_code)) {
            this.moveFocus('user_group');
            await this.$swal.fire('그룹을 선택해주세요.');
            return;
          }
        }
        if (this.validList.corp_no === false) {
          this.moveFocus('corp_num');
          await this.$swal.fire('사업자 번호를 인증해주세요.');
          return;
        }
        if (this.isEmpty(this.tmp_corp_email)) {
          this.memberCreateParam.email = '';
          this.memberCreateParam.taxemail = '';
        } else if (!this.validateEmail()) {
          this.moveFocus('corp_email');
          await this.$swal.fire({title: '올바른 이메일 형식을 입력해주세요.'});
          return;
        } else {
          this.memberCreateParam.taxemail = this.memberCreateParam.email;
        }

        if (this.joinUrl === 'mancharo') {
          if (this.hasBankData() && this.isValidBankInfo()) {
            // 은행관련 정보가 입력된 경우 검증은 필수 입니다.
            this.moveFocus('rbank_num');
            await this.$swal.fire('계좌정보를 입력시\n계좌인증은 필수입니다.');
            return;
          }
        } else if (this.isValidBankInfo()) {
          // 은행관련 정보가 입력된 경우 검증은 필수 입니다.
          this.moveFocus('rbank_num');
          await this.$swal.fire('계좌 인증을 해주세요.');
          return;
        }

        // 값이 있는 경우 체크하기
        if (!this.isAllRequiredAgreed()) {
          await this.$swal.fire('필수 약관에 모두 동의해주세요.');
          return;
        }
        if (this.signatureData == null) {
          await this.$swal.fire('서명을 해주세요.');
          return;
        }
        await this.fileUpload();
      }
      
      // 마케팅 동의 여부 설정
      this.memberCreateParam.marketing_agree = this.selectedItems['marketing_agreement'] ? 'Y' : 'N';
      
      this.memberCreateParam.grade_code = sessionStorage.getItem("grade-code");
      await this.$http.post('/api/user/add/cw', this.memberCreateParam)
          .then(response => {
            if (response.data.error === false) {
              const user_seq = response.data.data.seq;
              this.$store.commit('setUserSeq', user_seq);
              this.$store.commit('setGradeCode', this.memberCreateParam.grade_code);
              if (isSocialLogin()) { // 소셜 로그인
                const socialCorpName = this.$store.getters.getSocialCorpName;
                const socialId = this.$store.getters.getSocialId;
                this.$http.post('/api/simplejoin/social/id', {
                  user_seq: user_seq,
                  provider_corp_name: socialCorpName,
                  social_login_id: socialId,
                  mobile: this.memberCreateParam.mobile,
                  type: 1 // 차주 1 화주 2
                }).then(() => {
                  this.$emit('current-page', {page: 'default-completion'});
                }).catch(() => {
                  this.$emit('current-page', {page: 'default-completion'});
                })
              } else {
                this.$emit('current-page', {page: 'default-completion'});
              }
              return;
            }
            this.$swal.fire(response.data.message);
          })
          .catch(error => {
            this.$swal.fire(error.response.data.message);
          });
    },
    hasBankData() {
      // const bankType = this.memberCreateParam.rbank_type;
      const backCode = this.memberCreateParam.rbank_typecode;
      const bankNum = this.memberCreateParam.rbank_num;
      const bankName = this.memberCreateParam.rbank_username;
      return backCode.trim().length > 0 || bankNum.trim().length > 0 || bankName.trim().length > 0;
    },
    changeDetailAddress(event) {
      this.memberCreateParam.address2 = event.target.value;
    },
    changeCarNum(event) {
      this.memberCreateParam.user_carnum = event.target.value;
    },
    validateEmail() {
      this.replaceEmail();
      // eslint-disable-next-line
      const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.memberCreateParam.email === '' || !emailPattern.test(this.memberCreateParam.email)) {
        return false;
      }
      return true;
    },
    replaceEmail() {
      //이메일 직접입력일 경우
      if (this.selectEmail === '') {
        this.memberCreateParam.email = this.tmp_corp_email;
        return;
      }
      this.memberCreateParam.email = this.tmp_corp_email + this.selectEmail;
    },
    validCarNum() {
      const userCarNum = this.memberCreateParam.user_carnum;
      this.memberCreateParam.user_carnum = userCarNum.replace(/\s+/g, '');
      if (userCarNum.length != 9) {
        this.moveFocus('user_carnum');
        this.$swal.fire('차량번호를 정확히 입력하세요.');
        return false;
      }
      for (let i = 0; i < userCarNum.length; i++) {
        if (i == 0 || i == 1 || i == 4) {
          if (
              this.checkKor(userCarNum.substring(i, i + 1)) ==
              false
          ) {
            this.moveFocus('user_carnum');
            this.$swal.fire('차량번호(한글)를 정확히 입력해 주세요.');
            return false;
          }
        }
        if (i == 4) {
          if (
              userCarNum.substring(i, i + 1) == '바' ||
              userCarNum.substring(i, i + 1) == '사' ||
              userCarNum.substring(i, i + 1) == '아' ||
              userCarNum.substring(i, i + 1) == '자' ||
              userCarNum.substring(i, i + 1) == '배'
          ) {
            ////////
          } else {
            this.moveFocus('user_carnum');
            this.$swal.fire(
                '차량번호(숫자 뒤 한글-바,사,아,자,배)를 정확히 입력해 주세요.',
            );
            return false;
          }
        }
        if (i == 2 || i == 3 || i == 5 || i == 6 || i == 7 || i == 8) {
          if (
              this.checkNum(userCarNum.substring(i, i + 1)) ==
              false
          ) {
            this.moveFocus('user_carnum');
            this.$swal.fire('차량번호(숫자)를 정확히 입력해 주세요.');
            return false;
          }
        }
        // if (i == 2) {
        //   if (
        //       this.memberCreateParam.user_carnum.substring(i, i + 1) == '8' ||
        //       this.memberCreateParam.user_carnum.substring(i, i + 1) == '9'
        //   ) {
        //     ////////
        //   } else {
        //     // this.$alert.show(
        //     //     '차량번호(지역명 뒤 숫자-8 또는 9)를 정확히 입력해 주세요.',
        //     // );
        //     return false;
        //   }
        // }
      }
      return true;
    },
    // 한글 체크
    checkKor(str) {
      const regExp = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]*$/;
      if (regExp.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    // 숫자 체크
    checkNum(str) {
      const regExp = /^[0-9]*$/;
      if (regExp.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    initMemberInfo(memberInfo) {
      this.memberCreateParam.birthday = memberInfo.birth.length === 8 ? memberInfo.birth.substring(2, 8) : memberInfo.birth;
      this.memberCreateParam.name = memberInfo.name;
      this.memberCreateParam.mobile = memberInfo.mobile;
      this.memberCreateParam.corp_ceo_personno1 = memberInfo.birth.length === 8 ? memberInfo.birth.substring(2, 8) : memberInfo.birth;
      this.constGender = String(memberInfo.gender);
    },
    inputBankName(event) {
      this.memberCreateParam.rbank_username = event.target.value;
      this.validList.bank_no = false;
      this.memberCreateParam.rbank_check = 0;
    },
    inputBankNumber(event) {
      this.memberCreateParam.rbank_num = event.target.value;
      this.validList.bank_no = false;
      this.memberCreateParam.rbank_check = 0;
    },
    inputCorpNum(event) {
      this.memberCreateParam.corp_num = event.target.value;
      this.validList.corp_no = false;
      this.memberCreateParam.corp_check = 0;
    },
    inputPersonNo(event) {
      this.memberCreateParam.corp_ceo_personno_tmp = event.target.value;
      this.validList.person_no = false;
    },
    withoutHyphens(value) {
      return value.replace(/-/g, '');
    },
    carTypeChange() {
      const find = this.carTypeArray.find(type => type.option_code === this.carType);
      if (find === undefined) {
        this.memberCreateParam.user_cartype = '';
        this.memberCreateParam.user_cartypecode = '';
        return;
      }
      this.memberCreateParam.user_cartype = find.option_name;
      this.memberCreateParam.user_cartypecode = find.option_code;
    },
    carSizeChange() {
      const find = this.carSizeArray.find(size => size.option_code === this.carSize);
      if (find === undefined) {
        this.memberCreateParam.user_carsize = '';
        this.memberCreateParam.user_carsizecode = '';
        return;
      }
      this.memberCreateParam.user_carsize = find.option_name;
      this.memberCreateParam.user_carsizecode = find.option_code;
    },
    selectBankChange() {
      const find = this.bankArray.find(bank => bank.option_code === this.selectBank);
      if (find === undefined) {
        this.memberCreateParam.rbank_type = '';
        this.memberCreateParam.rbank_typecode = '';
        return;
      }
      this.memberCreateParam.rbank_type = find.option_name;
      this.memberCreateParam.rbank_typecode = find.option_code;
    },
    moveFocus(refTarget) {
      this.$refs[refTarget].focus();
    },
    generatedUserId() {
      let min = 100000;
      let max = 999999;

      // Math.random()을 사용하여 랜덤 숫자 생성 후 6자리로 만듭니다.
      let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

      return randomNumber.toString(); // 문자열로 반환
    }
  },
}
</script>

<style scoped>
.border-line {
  border-bottom: 4px solid cornflowerblue;
}

.mr-0 {
  margin-right: 0.75rem !important;
}

/* 모달 버튼 스타일링 */
.modal-btn {
  border: none; /* 테두리 없애기 */
  background: transparent; /* 배경 없애기 */
  cursor: pointer;
  font-size: 16px;
  color: #007bff; /* 버튼 색상 (원하는 색상으로 변경 가능) */
  padding: 0;
  display: flex;
  align-items: center;
}

.auto-width {
  width: 250px;
  height: 150px;
}

.ml-0 {
  margin-left: 0px !important;
}

.form-select {
  font-weight: normal;
  text-decoration: none;
  border-radius: 0;
  border: none;
  box-shadow: none;
  border-bottom: 1px solid #ccc;
  transition: border-color 0.2s;
  outline: none;
}

.form-select:focus {
  border-bottom: 1px solid #80bdff;
  outline: none !important;
  box-shadow: 0 0 0 0;
}

.custom-button {
  font-weight: bold !important; /* 버튼의 기본 글꼴을 굵은체로 설정 */
  color: #000 !important; /* 글자 색상을 완전히 검정으로 설정 */
  background-color: #ccc !important; /* 배경색을 회색 계열로 설정 */
  border-color: #ccc !important; /* 테두리 색상을 회색 계열로 설정 */
  transition: color 0.2s; /* 글자 색상 변경 트랜지션 추가 */
  margin-left: 1rem;
}

.custom-button:hover {
  background-color: #aaa !important; /* 버튼 위로 호버할 때 배경색을 더 진한 회색으로 변경 */
  border-color: #aaa !important; /* 버튼 위로 호버할 때 테두리 색상을 더 진한 회색으로 변경 */
  color: #fff !important; /* 버튼 위로 호버할 때 글자 색상을 흰색으로 변경 */
}

.custom-button:active {
  background-color: #888 !important; /* 버튼을 클릭할 때 배경색을 더 진한 회색으로 변경 */
  border-color: #888 !important; /* 버튼을 클릭할 때 테두리 색상을 더 진한 회색으로 변경 */
}

.detail-view {
  font-size: 0.8rem;
}

.w-40 {
  width: 40%;
}

select.form-select.email-select {
  min-width: 110px; /* 최소 너비를 원하는 값으로 설정 */
  max-width: 110px; /* 최대 너비를 원하는 값으로 설정 */
  width: 100%; /* 너비를 100%로 설정하여 부모 요소에 맞게 조절 */
}

.form-select {
  font-weight: normal;
  text-decoration: none;
  border-radius: 0;
  border: none;
  box-shadow: none;
  border-bottom: 1px solid #ccc;
  transition: border-color 0.2s;
  outline: none;
}

.form-select:focus {
  border-bottom: 1px solid #80bdff;
  outline: none !important;
  box-shadow: 0 0 0 0;
}

.valid-btn {
  border-radius: 0;
  padding: 0px 10px;
  margin: 4px 0px 0px 0px;
}

.input-none {
  padding-right: 0px !important;
  margin-right: 0px !important;
  pointer-events: none;
}

.p-info {
  padding: 6px 6px;
}

.form-check {
  margin-bottom: 0px;
}

.text-info {
  font-size: 0.8rem;
  font-weight: bold;
  word-break: keep-all;
  color: #319cd5 !important;
  background-color: white;
}

.border-primary {
  border-color: #319cd5 !important;
}
</style>